import SocialMediaLinksSFC from "./SocialMediaLinks.vue";
export const SocialMediaLinks = SocialMediaLinksSFC;
